module.exports = __webpack_public_path__ + "img/wzzj2-1.adc57b88.jpg";